export enum SimulationScenarioMarketEventDisplayMode {
    INDIVIDUAL_EVENT = 'INDIVIDUAL_EVENT',
    SEVERAL_EVENTS = 'SEVERAL_EVENTS',
}
